import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { CustomerFacade, CustomerService } from '@contact/upgrade';

import { default as CustomerCardOnly } from './customer-card-only/customer-card-only.module.ajs';
import { CustomerCardsDeprecatedService, default as customerCardsDeprecatedService } from './customer-cards-deprecated.service';

export default module('contact.commons.customer', [CustomerCardOnly])
  .service(customerCardsDeprecatedService, CustomerCardsDeprecatedService)
  .factory('customerFacade', downgradeInjectable(CustomerFacade) as any)
  .factory('customerService', downgradeInjectable(CustomerService) as any).name;
